/*
 *	Common app service used in all the components of the applications
 *
 *         It contains two methods
 *			a.getData used for get request method
 *			b.postData used for post request method and getting the response back
 */

import {reloadPage, UserAccessToken} from 'Global/UserAccessToken';
import { rateLimitErrorHandler } from 'Common/components/GenericErrorHandler';

const debugLog = (...args) => {
  if (process.env.NODE_ENV !== 'prod') {
    console.log(...args);
  }
};


 export var getToken = async (scope = process.env.API_SCOPE_DEV) => {
    
   var token =await UserAccessToken(scope);
    return token;
 };


const redirectToError = () => {
   window.location.href = '/Error';
};
const redirectToUnauthorized = () => {
  if(!window.location.href.includes('unauthorized')){
    window.location.href = '/unauthorized';
  }
};

var AppService = {
 
 async postData(reqObj, reqUrl, callback, inputHeader, typeObj, isCompleteUrl) {
   
   var url = reqUrl;
    
    if (isCompleteUrl) {
     url = reqUrl;
   }
   
  debugLog(JSON.stringify(reqObj));
   var timeout;
   var data;
   var contentType;
  debugLog("typeObj---->", reqObj.timeout);
   if (reqObj.timeout !== undefined) {
     timeout = reqObj.timeout;
     delete reqObj.timeout;
   } else {
     timeout = 60000;
   }
   if (typeObj !== undefined) {
     contentType = false;
     data = reqObj;
   } else {
     contentType = "application/json; charset=utf-8";
     data = JSON.stringify(reqObj);
   }

   $.ajax({
     url: url,
    
headers: {
        'Authorization':  "Bearer "+await getToken(),
        ...inputHeader
       },
     type: "post",
     dataType: "json",
     timeout: timeout,
     contentType: contentType,
     data: data,
     processData: false,
     success: function (success) {
      if (callback) {
        callback(success);
      }
     },
     error: function (err) {
      console.log("<--------------- Error ------------------>", err);
      if(err.status == 403 && err.responseText && err.responseText.includes("Gateway")){
        rateLimitErrorHandler();
      }
      if(err.status === 401){
        reloadPage();
      } else if(callback) {
        callback("", err);
      }

     },
     cache: false,
     crossDomain: true,
    
     contentType: "application/json; charset=utf-8",

     status: {
       401: function () {
        reloadPage();
       },
       500: function () {
         redirectToError();
       },
     },
   });
 },

 async postDataWithoutTimeOut(reqObj, reqUrl, callback, inputHeader, isCompleteUrl, timeout = 0) {
  var url = reqUrl;

  if (isCompleteUrl) {
    url = reqUrl;
  }

  // Check if reqObj is FormData, otherwise use JSON
  const isFormData = reqObj instanceof FormData;
  const contentType = isFormData ? false : "application/json; charset=utf-8";
  const data = isFormData ? reqObj : JSON.stringify(reqObj);

  $.ajax({
    url: url,
    timeout: timeout,
    headers: {
      Authorization: "Bearer " + (await getToken()),
      ...inputHeader,
    },
    type: "post",
    dataType: "json",
    data: data,
    contentType: contentType,
    processData: false,
    success: function (success) {
      callback(success);
    },
    error: function (err) {
      console.log("<--------------- Error ------------------>", err);
      if (err.status === 401) {
        reloadPage();
      } else if (err.status === 500) {
        callback("", err, err.status);
      } else if (err.status === 403) {
        if(err.responseText && err.responseText.includes("Gateway")){
          rateLimitErrorHandler();
        }else{
          callback("", err, err.status);
        }
      } else {
        callback("", err, err.status);
      }
    },
    cache: false,
    crossDomain: true,
    status: {
      401: function () {
        reloadPage();
      },
      500: function () {
        redirectToError();
      },
    },
  });
},
 
 async putData(reqObj, reqUrl, callback, inputHeader, typeObj, isCompleteUrl) {
   
  var url = reqUrl;
   
   if (isCompleteUrl) {
    url = reqUrl;
  }
  
  debugLog(JSON.stringify(reqObj));
  var timeout;
  var data;
  var contentType;
  debugLog("typeObj---->", reqObj.timeout);
  if (reqObj.timeout !== undefined) {
    timeout = reqObj.timeout;
    delete reqObj.timeout;
  } else {
    timeout = 60000;
  }
  if (typeObj !== undefined) {
    contentType = false;
    data = reqObj;
  } else {
    contentType = "application/json; charset=utf-8";
    data = JSON.stringify(reqObj);
  }

  $.ajax({
    url: url,
   
headers: {
       'Authorization':  "Bearer "+await getToken(),
       ...inputHeader
      },
    type: "put",
    dataType: "json",
    timeout: timeout,
    contentType: contentType,
    data: data,
    processData: false,
    success: function (success) {
      callback(success);
    },
    error: function (err) {
      console.log("<--------------- Error ------------------>", err);
     if(err.status === 401){
       reloadPage();
     }else if(err.status === 500) {
       callback("", err);
     }else if(err.status === 403) {
      if(err.responseText && err.responseText.includes("Gateway")){
        rateLimitErrorHandler();
      }else{
        callback("", err);
      }
     }else{
       callback("", err);
     }

    },
    cache: false,
    crossDomain: true,
   
    contentType: "application/json; charset=utf-8",

    status: {
      401: function () {
       reloadPage();
      },
      500: function () {
        redirectToError();
      },
    },
  });
},

async deleteData(reqObj, url, callback, inputHeader) {
  let timeout = 60000;
  let data = JSON.stringify(reqObj);
  let contentType = "application/json; charset=utf-8";

  if (reqObj.timeout !== undefined) {
    timeout = reqObj.timeout;
    delete reqObj.timeout;
  }

  $.ajax({
    url,
    headers: {
       'Authorization':  "Bearer "+await getToken(),
       ...inputHeader
    },
    type: "DELETE",
    dataType: "json",
    timeout,
    contentType,
    data,
    processData: false,
    cache: false,
    crossDomain: true,
    success: function (success) {
      callback(success);
    },
    error: function (err) {
      console.log("<--------------- Error ------------------>", err);
      if (err.status === 401){
        reloadPage();
      } else if(err.status === 500) {
        callback("", err);
      } else if(err.status === 403) {
        if(err.responseText && err.responseText.includes("Gateway")){
          rateLimitErrorHandler();
        }else{
          callback("", err);
        }
      } else{
        callback("", err);
      }
    },
    status: {
      401: function () {
       reloadPage();
      },
      500: function () {
        redirectToError();
      },
    },
  });
},

 /* Used by RDS to verify Status of Instrument weather it is connected or not */

 async getStatus (url, instanceId,callbackSuccess,callbackFailure,isCompleteUrl) {
  debugLog('get status - instance' + instanceId)
   $.ajax({
       url: url,
       headers: {
        'Authorization':  "Bearer "+await getToken(),
        'AUTH_OBJECT':""+instanceId
        },
         type: 'get',
         timeout: 60000,
     statusCode: {
       200: function () {
         debugLog('Getting postive reponse')
         callbackSuccess();
         },

     },
     error: function (err){
        debugLog('Getting Negative reponse in Verify'+JSON.stringify(err))
        callbackFailure(err);}
 

     });
 },
 
  /* Used by RDS to To download the file */

  async fileDownload(reqObj, url, callback, instanceId) {
    
    debugLog('<------------------Payload Object is ------------------>', JSON.stringify(reqObj));

    // Use the fixed timeout value
    const timeoutMs = process.env.RDS_API_TIMEOUT;

    // Stringify the request object for the body
    const postData = JSON.stringify(reqObj);

    // --- Handle Timeout with AbortController ---
    // Create an AbortController and a signal
    const controller = new AbortController();
    const signal = controller.signal;

    // Set a timeout. If the fetch doesn't complete within the time,
    // the signal will be triggered, and the fetch promise will reject with an AbortError.
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
    // ------------------------------------------

    try {
        // Await the token before making the fetch call
        const token = await getToken();

        // --- Perform the Fetch Request ---
        const response = await fetch(url, {
            method: 'POST', // Corresponds to type: "post"
            headers: {
                'Authorization': "Bearer " + token,
                'Cache-Control': "no-cache",
                'AUTH_OBJECT': instanceId, // Pass the instanceId via header as in original
                'Content-Type': 'application/json', // Corresponds to contentType
              
            },
            body: postData, // Corresponds to data
            signal: signal, // Link the request to the abort signal for timeout
        });
        // -----------------------------------

        // Clear the timeout as soon as the fetch promise settles (either resolves or rejects with status)
        // Note: Network errors still go to the catch block before clearing
        clearTimeout(timeoutId);

        // --- Handle Response Status ---
        if (response.status === 200) {
            // SUCCESS SCENARIO (Matches the original statusCode.200 handler)
            debugLog("Request successful! Status:", response.status);

            const contentType = response.headers.get('Content-Type');
            // Get the response body as ArrayBuffer, matching xhrFields: { responseType: 'arraybuffer' }
            const arrayBuffer = await response.arrayBuffer();

            let blob;
            let filename;

            // Create the Blob and filename based on Content-Type
            if (contentType && contentType.includes('application/zip')) { // Use includes in case of charset like application/zip;charset=UTF-8
                blob = new Blob([arrayBuffer], { type: "application/zip" });
                filename = 'Start-RDS-' + instanceId + '.zip';
            } else if (url && url.includes('/launchRAPBoxRDS')) {
                blob = new Blob([arrayBuffer], { type: "text/plain" });
                filename = 'Start-RDS-' + instanceId + '.bat';
            } else { // Assuming text/plain for .vnc if not zip
                 // Use includes in case of charset
                blob = new Blob([arrayBuffer], { type: "text/plain" });
                filename = 'Start-RDS-' + instanceId + '.vnc';
            }

            // --- Trigger File Download ---
            const a = document.createElement('a');
            const blobUrl = window.URL.createObjectURL(blob);
            a.href = blobUrl;
            a.download = filename;
            // Append to body, click, and remove for download
            document.body.appendChild(a); // Use appendChild for broader compatibility
            a.click();

            // Clean up the temporary link and object URL
            document.body.removeChild(a);
            window.URL.revokeObjectURL(blobUrl);
            // -----------------------------

            // Call the success callback - original passed the arraybuffer
            callback(arrayBuffer);

        } else {
          
            // Attempt to read the error body as text first
            let errorText = null; // Define outside try block to potentially access in catch
            try {
                // Get the error response body as text
                errorText = await response.text();
                

                // Attempt to parse the error body as JSON
                const errorJson = JSON.parse(errorText);
                
                if (process.env.NODE_ENV !== 'prod') {
                  debugLog("Parsed error JSON:", errorJson);
                }
                  

                // Call the error callback - original signature is callback('', err)
                // We'll pass a structured object as the 'err' part
                const errorDetails = {
                    status: response.status,
                    statusText: response.statusText,
                    responseJson: errorJson,
                    rawText: errorText,
                };
                callback('', errorDetails); // Pass null for data, and the error details object


            } catch (parseOrReadError) {
                // Handle errors that occur when reading the response body as text
                // or when parsing the text as JSON
                console.error("Error reading or parsing error response body:", parseOrReadError);

                // Pass the error details including the status and any available raw text
                const errorDetails = {
                    status: response.status,
                    statusText: response.statusText,
                    parseError: parseOrReadError,
                     rawText: errorText, // Include the raw text if reading succeeded but parsing failed
                };
                callback('', errorDetails); // Pass null for data, and the error details object
            }
        }

    } catch (err) {
        // This catch block handles:
        // 1. Network errors (fetch itself fails)
        // 2. Timeout errors (AbortError from controller.abort())
        // 3. Errors thrown *before* the fetch (e.g., await getToken() fails)
        // 4. Errors thrown *within* the await response.arrayBuffer() or await response.text()

        // Ensure timeout is cleared even if an error occurred before the status check
        clearTimeout(timeoutId);

        console.error("Fetch operation failed:", err);

        // Check if it's a timeout error explicitly
        if (err.name === 'AbortError') {
            console.error("Request timed out.");
             // Call the error callback with timeout indication
             callback('', { status: 'timeout', message: 'Request timed out', error: err });
        } else {
            // Handle other errors (network error, getToken error, etc.)
             callback('', { status: 'network', message: 'Network or unexpected error', error: err });
        }
    }
},
async getData (reqUrl, callback, inputHeader,isCompleteUrl) {

  let url = reqUrl;
  let IS_AUTH_ENABLED = true;
  $.ajax({
    url: url,
    timeout: 60000,
    type: 'get',
    dataType: 'json',
    success: function (success) {
      callback(success);
    },
    error: function (err) {
      console.log("<--------------- Error ------------------>", err);
      if(err.status == 403 && err.responseText && err.responseText.includes("Gateway")){
        rateLimitErrorHandler();
      }

      if(err.status!==401){
        callback('', err);
      }
      if(err.status == 200){
        callback(err);
      }
      debugLog('error', err);

    },
    cache : false,
    crossDomain : true,
    headers : IS_AUTH_ENABLED ? {
      'Authorization': "Bearer "+await getToken(),
      ...inputHeader
    }:{},
    statusCode : {
      401 : function(){
        reloadPage()

      }
    }

  });
},

async getDataWithoutTimeout (reqUrl, callback, inputHeader,isCompleteUrl) {

  let url = reqUrl;
  let IS_AUTH_ENABLED = true;
  $.ajax({
    url: url,
    type: 'get',
    dataType: 'json',
    success: function (success) {
      callback(success);
    },
    error: function (err) {
      console.log("<--------------- Error ------------------>", err);
      if(err.status == 403 && err.responseText && err.responseText.includes("Gateway")){
        rateLimitErrorHandler();
      }

      if(err.status!==401){
        callback('', err);
      }
      if(err.status == 200){
        callback(err);
      }
      debugLog('error', err);

    },
    cache : false,
    crossDomain : true,
    headers : IS_AUTH_ENABLED ? {
      'Authorization': "Bearer "+await getToken(),
      ...inputHeader
    }:{},
    statusCode : {
      401 : function(){
        reloadPage()

      }
    }

  });
},


startDownload(blobUrl){
  const anchor = document.createElement('a');
  anchor.href = blobUrl;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
},
async getFile (reqUrl, callback, fileName,isCompleteUrl) {

  const options = {
    headers: {
      Authorization: "Bearer " + await getToken()
    }
  };

  const startTime = new Date().getTime();
  let request = new XMLHttpRequest();
  request.responseType = "blob";
  request.open("get", reqUrl, true);
  request.setRequestHeader("Authorization", options.headers.Authorization)
  request.send();
  let statusTracker = {}
  request.onreadystatechange = function() {
    statusTracker.progress = false;
    if(this.readyState == 4 && this.status == 200){
      const url = window.URL.createObjectURL(this.response);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = fileName;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      statusTracker.result = true
      // callback(statusTracker);
    }else if(this.readyState == 4 && this.status != 200){
      statusTracker.error = true
      callback(statusTracker);
    }
  };
  request.onprogress = function (e){
    const percent_complete = Math.floor((e.loaded / e.total) * 100);
    const duration = (new Date().getTime() - startTime) / 1000;
    const bps = e.loaded / duration;
    const kbps = Math.floor(bps / 1024);
    const time = (e.total - e.loaded )/ bps;
    const seconds = Math.floor(time %60);
    const minutes = Math.floor(time / 60);
    const hours = Math.floor(time / (60*60));
    let timeRem = hours?hours+" hours " :""
    timeRem += minutes?minutes+" minutes ":"" 
    timeRem += seconds?seconds+" seconds " :""
    statusTracker.progress = true;
    statusTracker.status = {
      status: percent_complete,
      speed: kbps,
      estimatedTime: timeRem
    }
    // callback(statusTracker);
    debugLog(`${percent_complete}% - ${kbps} Kbps - ${minutes} min ${seconds} sec remaining`);
  }
},
 
async uploadFile(url, payload, callback){
  const options = {
    headers: {
      Authorization: "Bearer " + await getToken()
    }
  };

  const startTime = new Date().getTime();
  let formData = new FormData();
  formData.append("hostPath", payload.hostPath);
  formData.append("file", payload.file);
  
  let request = new XMLHttpRequest();
  
  request.open('post', url, true);
  request.setRequestHeader("Authorization", options.headers.Authorization);

  request.upload.onprogress = function (e){
    const percent_complete = Math.floor((e.loaded / e.total) * 100);
    const duration = (new Date().getTime() - startTime) / 1000;
    const bps = e.loaded / duration;
    const kbps = Math.floor(bps / 1024);
    const time = (e.total - e.loaded )/ bps;
    const seconds = Math.floor(time %60);
    const minutes = Math.floor(time / 60);
    const hours = Math.floor(time / (60*60));

    let timeRem = hours ? ((hours == 1) ? hours+" Hour " : hours+" Hours ") :"";
    timeRem += minutes ? ((minutes == 1) ? minutes+" Minute " : minutes+" Minutes ") :""; 
    timeRem += seconds ? ((seconds == 1) ? seconds+" Second " : seconds+" Seconds ") :"";
    timeRem += seconds ? "remaining" : "";
    statusTracker.progress = true;
    statusTracker.status = {
      percent: percent_complete,
      speed: kbps,
      estimatedTime: timeRem
    }
    callback(statusTracker);
    debugLog(`${percent_complete}% - ${kbps} Kbps - ${minutes} min ${seconds} sec remaining`);
  };

  request.send(formData);

  let statusTracker = {}
  request.onreadystatechange = function() {
    statusTracker.progress = false;
    if(this.readyState == 4 && this.status == 200){
      callback("", this.response);
    }else if(this.readyState == 4 && this.status != 200){
      statusTracker.error = true
      callback("", "", statusTracker);
    }
  };
  

}
};

/**
 * method used to download a file using fetch api
 * @param {string} url is the url to be called
 * @param {function} callback is the callback to be called on response 
 * @param {string} fileName is the name of the file to be saved on the drive
 * @param {string} method is the http method type
 * @param {Object} payload is the payload to be sent
 * @param {string} authObject is the AUTH_OBJECT header value
 */
async function getDownloadRequestConfig(method, payload, authObject) {
  const config = {};

  config.method = method || 'GET';

  const headers = new Headers();
  headers.append('Authorization', `Bearer ${await getToken()}`);
  headers.append('Cache-Control', 'no-cache');
  headers.append('AUTH_OBJECT', authObject ? authObject : '*');
  headers.append('Content-Type', 'application/json');
  config.headers = headers;

  const body = !!payload ? JSON.stringify(payload) : undefined;
  if (payload) {
    config.body = body;
  }

  return config;
}

export async function downloadFile(url, callback, fileName, method, payload, authObject) {
  const config = await getDownloadRequestConfig(method, payload, authObject);

  fetch(url, config)
  .then(response => {
    if (response.ok) {
      return response.blob();
    }
    throw new Error();
  }, err => callback(null, err))
  .then(blobby => {
    const objectUrl = window.URL.createObjectURL(blobby);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.URL.revokeObjectURL(objectUrl);
    callback('success', null);
  }, err => callback(null, err));
}

/**
 * method used to download a file using fetch api while preserving response status and error payload
 * @param {string} url is the url to be called
 * @param {function} callback is the callback to be called on response
 * @param {string} fileName is the name of the file to be saved on the drive
 * @param {string} method is the http method type
 * @param {Object} payload is the payload to be sent
 * @param {string} authObject is the AUTH_OBJECT header value
 */
export async function downloadFileWithStatus(url, callback, fileName, method, payload, authObject) {
  const config = await getDownloadRequestConfig(method, payload, authObject);

  fetch(url, config)
    .then(async (response) => {
      if (response.ok) {
        const blobby = await response.blob();
        const objectUrl = window.URL.createObjectURL(blobby);
        const anchor = document.createElement('a');
        anchor.href = objectUrl;
        anchor.download = fileName;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        window.URL.revokeObjectURL(objectUrl);
        callback('success', null);
        return;
      }

      let errorPayload = {};

      try {
        errorPayload = await response.json();
      } catch (e) {
        errorPayload = {
          status: response.status,
          debugMessage: response.statusText,
        };
      }

      callback(null, {
        ...errorPayload,
        statusCode: response.status,
      });
    })
    .catch((err) => callback(null, err?.responseJSON || err));
}



export default AppService;
